module.exports = "/_next/static/images/canadiannanny.ca-6942c222e316a6cc2c73b78b3bc6a26b.svg";